import { FormHelperText, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { createYupErrorsObject } from "../../../../helpers";
import * as auth from "../../../../redux/Auth";
import { login } from "../../../../services/auth";
import schema from "./schema";
import "./styles.css";

function Login({ login: loginAction }) {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState([]);
  const [snackbar, setSnackbar] = useState(false);

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleCloseSnackbar = () => {
    setSnackbar(false);
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const authenticate = async e => {
    enableLoading();
    e.preventDefault();
    try {
      await schema.validate({ email, password }, { abortEarly: false });
      const res = await login(email, password, "DIRECTOR");
      loginAction(res.data.access_token);
    } catch (e) {
      if (e.name === "ValidationError" && e.inner) {
        setErrors(createYupErrorsObject(e));
      } else {
        setSnackbar(true);
      }
      disableLoading();
    }
  };

  return (
    <>
      <div className="login-form login-signin" id="kt_login_signin_form">
        <div className="mb-5 mb-lg-10">
          <h3 className="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">
            Entre com sua conta
          </h3>
          <p className="text-muted font-weight-bold">
            Entre com seu e-mail e senha
          </p>
        </div>
        <form className="form fv-plugins-bootstrap fv-plugins-framework">
          <div className="form-group fv-plugins-icon-container">
            <label className="font-size-h6 font-weight-bolder text-dark">
              Seu email
            </label>
            <input
              placeholder="Email"
              type="email"
              className={`form-control form-control-solid h-auto py-7 px-6 rounded-lg`}
              onChange={e => setEmail(e.target.value)}
            />
            {errors && errors?.email ? (
              <FormHelperText className="error-font mt-2" error>
                {errors.email}
              </FormHelperText>
            ) : null}
          </div>
          <div className="form-group fv-plugins-icon-container">
            <label className="font-size-h6 font-weight-bolder text-dark">
              Sua senha
            </label>
            <input
              placeholder="Password"
              type="password"
              className={`form-control form-control-solid h-auto py-7 px-6 rounded-lg`}
              onChange={e => setPassword(e.target.value)}
            />
            {errors && errors?.password ? (
              <FormHelperText className="error-font mt-2" error>
                {errors.password}
              </FormHelperText>
            ) : null}
          </div>
          <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
            <Link
              to="/auth/forgot-password"
              className="text-primary font-size-h6 font-weight-bolder text-hover-primary"
              id="kt_login_forgot"
            >
              Esqueceu sua senha?
            </Link>
            <button
              id="kt_login_signin_submit"
              type="submit"
              disabled={loading}
              className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
              onClick={authenticate}
            >
              <span className="signIn-text">Entrar</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </form>
      </div>
      <Snackbar
        open={snackbar}
        autoHideDuration={2500}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity={"error"}>
          {"Usuário e/ou senha incorretos."}
        </Alert>
      </Snackbar>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
